import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
	fetchChannelAvailability,
	deleteChannelAvailability
} from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from './channels_availability_columns';

// Import components
import { TableTemplate } from 'components/common/templates';

const ChannelsAvailability = ({
	error,
	fetchChannelAvailability,
	deleteChannelAvailability,
	resources,
	match: {
		params: { id }
	}
}) => {
	const { t } = useTranslation();

	return (
		// Dispatch fetchChannelAvailability, deleteChannelAvailability action in channels_availability
		<TableTemplate
			itemId={id}
			error={error}
			type={`channels/${id}/availability`}
			typeText="availability"
			addLinkText={t('availability:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchChannelAvailability}
			deleteItemAction={deleteChannelAvailability}
			notificationDeleteSuccessTxt={t(
				'availability:notification.delete_success'
			)}
			notificationDeleteErrorTxt={t('availability:notification.delete_error')}
		></TableTemplate>
	);
};

ChannelsAvailability.propTypes = {
	error: PropTypes.bool.isRequired,
	resources: PropTypes.object.isRequired,
	fetchChannelAvailability: PropTypes.func.isRequired,
	deleteChannelAvailability: PropTypes.func.isRequired,
	match: PropTypes.shape({
		params: PropTypes.shape({ id: PropTypes.string.isRequired })
	})
};

const mapStateToProps = ({ channels: { availability } }) => ({
	error: availability.table.error,
	resources: availability.table
});

export default compose(
	connect(mapStateToProps, {
		fetchChannelAvailability,
		deleteChannelAvailability
	}),
	withRouter
)(ChannelsAvailability);
